import { useQuery } from "@apollo/client";
import FETCH_VIEWER from "./queries/viewer.gql";

const useAuthViewer = () => {
  const { data, error, loading } = useQuery(FETCH_VIEWER);

  const viewer = data?.viewer
    ? { ...data.viewer, name: `${data.viewer.first_name} ${data.viewer.last_name}` }
    : null;

  return { error, loading, viewer };
};

export default useAuthViewer;
